import { useState, useEffect, useReducer } from "react";
import DashboardLayout from "../../layoutcontainers/DashboardLayout";
import ConfirmationDialog from "../../components/Dialog/ConfirmationDialog";
import {
  Card,
  CardContent,
  CardHeader,
  Stack,
  IconButton,
  Snackbar,
  Alert,
  ButtonGroup,
  FormControl,
  FormHelperText,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import MaterialTypography from "../../components/MaterialTypography";
import MaterialBox from "../../components/MaterialBox";
import MaterialInput from "../../components/MaterialInput";
import MaterialButton from "../../components/MaterialButton";
import MaterialSnackbar from "../../components/MaterialSnackbar";
import NotificationsIcon from "@mui/icons-material/Notifications";

import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";

import MaterialSelect from "../../components/MasterSelect";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";

import AddBoxIcon from "@mui/icons-material/AddBox";
import VerifiedOutlinedIcon from "@mui/icons-material/VerifiedOutlined";

import { City, Country, State } from "country-state-city";
import Swal from "sweetalert2";
import { useLoading } from "../../context/loading";
import { CompanyState, handlechange } from "./Statemanagement";

import { apicall } from "../Integration/apicall";
import { getbranch, getcompany } from "./query";
import { useLocation, useNavigate } from "react-router-dom";
import { addbranch, deletebranch, updatebranch, verifyifsc } from "./mutation";
import { useUserDetails } from "../../context/auth";

const AddBranch = () => {
  const nav = useNavigate();
  const location = useLocation();
  const { AccessData } = useUserDetails();
  const [IFSCmessages, setIFSCmessages] = useState("");
  const { type = "add", branchid = 0 } = location.state || {};

  const [pagestatus, setpagestatus] = useState({
    edit: false,
    view: false,
    add: false,
  });
  console.log(pagestatus, "pgstat");

  const [state, dispatch] = useReducer(handlechange, CompanyState);
  console.log(state, "statedata");

  const [id, setid] = useState("");
  const { setCirleLoading } = useLoading();

  const [companyname, setcompanyname] = useState("");
  const [snackbar, setsnackbar] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const [confirmationDialog, setConfirmationDialog] = useState({
    open: false,
    title: "",
    message: "",
    showCancel: true,
    customSection: null,
    onConfirm: () => {},
    onCancel: () => {},
  });

  const salutions = [
    {
      value: "MR",
      label: "MR",
    },
    {
      value: "MS",
      label: "MS",
    },
  ];
  console.log(type, "typee");

  useEffect(() => {
    fetchcompany();
    setpagestatus({
      add: type == "add" ? true : false,
      edit: type == "edit" ? true : false,
      view: type == "view" ? true : false,
    });
    if (branchid > 0) {
      //fetch branch details
      fetchbranch();
    }
  }, []);

  const fetchcompany = async () => {
    try {
      const res = await apicall(getcompany);
      console.log(res.success, "resdataaa");

      let success = res.success;
      console.log(success, "succdata");

      let data = res.data.data.getCompany.company;
      console.log(data.length, "company data");

      if (success) {
        console.log("inside if");
        if (data.length) {
          setcompanyname(data[0]?.companyName);
          dispatch({ field: "companyId", value: data[0]?.id });
        } else {
          Swal.fire({
            position: "center",
            icon: "error",
            title: "Company Hasn't Created Yet !,Create One",
            showConfirmButton: false,
            timer: 2500,
          }).then(() => {
            nav("/company");
          });
        }
      } else {
        console.log("inside else");

        Swal.fire({
          position: "center",
          icon: "error",
          title: "Cannot Fetch Company Try After Some Time",
          showConfirmButton: false,
          timer: 2500,
        }).then(() => {
          nav("/dashboard");
        });
      }
    } catch (err) {
      console.log("inside catch");
      Swal.fire({
        position: "center",
        icon: "error",
        title: "Cannot Fetch Company Try After Some Time",
        showConfirmButton: false,
        timer: 2500,
      }).then(() => {
        nav("/dashboard");
      });
    }
  };

  const fetchbranch = async () => {
    try {
      const res = await apicall(getbranch, { id: branchid });
      console.log(res.success, "resdataaa");

      let success = res.success;
      console.log(success, "succdata");

      let data = res.data.data.getBranchById.branch;
      console.log(data.length, "company data");

      let message = res.data.data.message;

      if (success) {
        console.log("inside if");
        if (data.length) {
          setpagestatus({
            edit: false,
            view: true,
            add: false,
          });

          // setcompany(data[0]);
          const companydata = data[0];
          for (let [key, value] of Object.entries(companydata)) {
            if (key === "contactInfo") {
              value.forEach((info, index) => {
                dispatch({
                  value: { value: info?.salutation, label: info?.salutation },
                  field: "contactInfo",
                  index,
                  arrayfield: "salutation",
                });

                dispatch({
                  value: info?.name,
                  field: "contactInfo",
                  index,
                  arrayfield: "name",
                });

                dispatch({
                  value: info?.designation,
                  field: "contactInfo",
                  index,
                  arrayfield: "designation",
                });

                dispatch({
                  value: info?.phoneNumber,
                  field: "contactInfo",
                  index,
                  arrayfield: "phoneNumber",
                });

                dispatch({
                  value: info?.email,
                  field: "contactInfo",
                  index,
                  arrayfield: "email",
                });
                dispatch({
                  value: info?.id,
                  field: "contactInfo",
                  index,
                  arrayfield: "id",
                });
              });
            } else {
              if (
                key === "city" ||
                key === "state" ||
                key === "country" ||
                key === "ownershipType"
              ) {
                dispatch({
                  value: { value, label: value },
                  field: key,
                });
              } else {
                dispatch({
                  value,
                  field: key,
                });
              }
            }
          }
        } else {
          setpagestatus({
            edit: false,
            view: false,
            add: true,
          });
        }
      } else {
        console.log("inside else");

        Swal.fire({
          position: "center",
          icon: "error",
          title: "Cannot Fetch Company Try After Some Time",
          showConfirmButton: false,
          timer: 2500,
        }).then(() => {
          nav("/dashboard");
        });
      }
    } catch (err) {
      console.log("inside catch");
      Swal.fire({
        position: "center",
        icon: "error",
        title: "Cannot Fetch Company Try After Some Time",
        showConfirmButton: false,
        timer: 2500,
      }).then(() => {
        nav("/dashboard");
      });
    }
  };

  const create_or_edit_company = async () => {
    try {
      let statusremovedstate = removeStatusFields(state);
      console.log(statusremovedstate, "statusremovedstate");

      let createbranch = pagestatus.add;
      let updatedcontactinfo = statusremovedstate.contactInfo.map((info) => ({
        ...info,
        salutation: info?.salutation?.value,
      }));
      let updatedstate = {
        ...(pagestatus?.edit ? { id: branchid } : {}),
        input: {
          ...statusremovedstate,
          country: statusremovedstate?.country?.value,
          city: statusremovedstate?.city?.value,
          state: statusremovedstate?.state?.value,
          ownershipType: statusremovedstate?.ownershipType?.value,
          contactInfo: updatedcontactinfo,
        },
      };

      //create
      const res = await apicall(
        createbranch ? addbranch : updatebranch,
        updatedstate
      );

      if (res.success) {
        const message = createbranch
          ? res.data.data.createBranch.message
          : res.data.data.updateBranch.message;
        const success = createbranch
          ? res.data.data.createBranch.success
          : res.data.data.updateBranch.success;
        Swal.fire({
          position: "center",
          icon: success ? "success" : "error",
          title: message,
          showConfirmButton: false,
          timer: 2500,
        }).then(() => {
          nav("/branch");
        });
      } else {
        Swal.fire({
          position: "center",
          icon: "error",
          title: "Cannot Able to Create or Update",
          showConfirmButton: false,
          timer: 2500,
        }).then(() => {
          nav("/branch");
        });
      }
    } catch (err) {
      Swal.fire({
        position: "center",
        icon: "error",
        title: "Cannot Able to Create or Update",
        showConfirmButton: false,
        timer: 2500,
      }).then(() => {
        nav("/branch");
      });
    }
  };
  const Deletebranch = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirm Delete",
      message: "Are You Sure You Want to delete The Branch ?",
      showCancel: true,
      showConfirm: true,
      customSection: null,
      onConfirm: () =>
        apicall(deletebranch, { id: branchid })
          .then((res) => {
            let success = res.data.data.deleteBranch.success;
            let message = res.data.data.deleteBranch.message;
            Swal.fire({
              position: "center",
              icon: success ? "success" : "error",
              title: message,
              showConfirmButton: false,
              timer: 2500,
            }).then(() => {
              nav("/branch");
            });
          })
          .catch((err) =>
            Swal.fire({
              position: "center",
              icon: "error",
              title: "Cannot Able to delete! delete after Sometime",
              showConfirmButton: false,
              timer: 2500,
            }).then(() => {
              nav("/branch");
            })
          ),
      onCancel: () => {
        setConfirmationDialog((prev) => ({
          ...prev,
          open: false,
        }));
      },
    });
  };

  const verifyifsccode = async () => {
    if (state.ifscCode) {
      apicall(verifyifsc, { ifscCode: state.ifscCode })
        .then((res) => {
          console.log(res, "fetched ifsc");

          let success = res?.data?.data?.checkIfscCode?.success;
          let data = null;
          if (success) {
            data = res?.data?.data?.checkIfscCode?.data;
            let branch = data?.BRANCH;
            let address = data?.ADDRESS;
            let state = data?.STATE;
            setIFSCmessages(branch + " " + address + " " + state);
          } else {
            setIFSCmessages("IFSC Not verified");
          }
          // setsnackbar({
          //   open:true,
          //   message:success?"Verified IFSC":"Not Verified IFSC",
          //   severity:success?"success":"error"
          // })
        })
        .catch((err) => setIFSCmessages("IFSC Not verified"));
    }
  };

  const removeStatusFields = (stateObj) => {
    const cleaned = {};

    for (const key in stateObj) {
      if (key.endsWith("Status")) continue;

      if (key === "contactInfo" && Array.isArray(stateObj[key])) {
        // Clean each contact object
        cleaned[key] = stateObj[key].map((contact) => {
          const newContact = {};
          for (const contactKey in contact) {
            if (!contactKey.endsWith("Status")) {
              newContact[contactKey] = contact[contactKey];
            }
          }
          return newContact;
        });
      } else {
        cleaned[key] = stateObj[key];
      }
    }

    return cleaned;
  };

  return (
    <DashboardLayout>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={5000}
        onClose={() =>
          setsnackbar({
            open: false,
            message: "",
            severity: "", // optionally reset severity
          })
        }
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }} // nice placement
      >
        <Alert
          onClose={() =>
            setsnackbar({
              open: false,
              message: "",
              severity: "",
            })
          }
          severity={snackbar.severity || "info"} // success, error, warning, info
          variant="filled" // or "outlined"
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
      {confirmationDialog.open && (
        <ConfirmationDialog
          open={confirmationDialog.open}
          title={confirmationDialog.title}
          message={confirmationDialog.message}
          showCancel={confirmationDialog.showCancel}
          showConfirm={true}
          customSection={confirmationDialog.customSection}
          onConfirm={confirmationDialog.onConfirm}
          onCancel={confirmationDialog.onCancel}
        />
      )}

      <Card>
        <CardHeader
          title={
            <>
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                spacing={2}
              >
                <Stack direction="column" spacing={0}>
                  <MaterialTypography variant="h5" fontWeight="medium">
                    {pagestatus?.add
                      ? "Add"
                      : pagestatus?.edit
                      ? "Edit"
                      : "View"}{" "}
                    Branch Details
                  </MaterialTypography>
                </Stack>
                {AccessData &&
                  Array.isArray(AccessData) &&
                  AccessData.some(
                    (item) => item.component === "EditBranch" && item.can_access
                  ) &&
                  pagestatus.view && (
                    <ButtonGroup
                      variant="outlined"
                      aria-label="Loading button group"
                    >
                      <MaterialButton
                        variant="gradient"
                        color="dark"
                        onClick={() =>
                          setpagestatus({ edit: true, view: false, add: false })
                        }
                        startIcon={<EditIcon />}
                      >
                        Edit
                      </MaterialButton>
                      {/* Uncomment if delete button is needed */}
                      <MaterialButton
                        variant="gradient"
                        color="dark"
                        onClick={Deletebranch}
                        startIcon={<DeleteIcon />}
                      >
                        Delete
                      </MaterialButton>
                    </ButtonGroup>
                  )}
              </Stack>
            </>
          }
        />
        <CardContent sx={{ minHeight: "55vh" }}>
          <MaterialBox>
            <Grid container spacing={1}>
              {/* section 1*/}
              <Grid size={{ xs: 5, sm: 4, lg: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Company Name <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>

                <MaterialInput
                  name="companyname"
                  value={companyname}
                  disabled={true}
                />
              </Grid>

              {/* branchname */}

              <Grid size={{ xs: 5, sm: 4, lg: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Branch Name <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>

                <MaterialInput
                  // placeholder="eg. IT"
                  value={state?.branchName}
                  onChange={(e) =>
                    dispatch({
                      value: e.target.value,
                      field: "branchName",
                    })
                  }
                  error={state.branchNameStatus === "error"}
                  success={state.branchNameStatus === "success"}
                  disabled={pagestatus.view === true ? true : false}
                />
              </Grid>

              {/* branchcode */}

              <Grid size={{ xs: 5, sm: 4, lg: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Branch Code <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>

                <MaterialInput
                  // placeholder="eg. IT"
                  value={state?.branchCode}
                  onChange={(e) =>
                    dispatch({
                      value: e.target.value,
                      field: "branchCode",
                    })
                  }
                  error={state.branchCodeStatus === "error"}
                  success={state.branchCodeStatus === "success"}
                  disabled={pagestatus.view === true ? true : false}
                />
              </Grid>

              <Grid size={{ xs: 5, sm: 4, lg: 6 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Address1 <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>

                <MaterialInput
                  name="address"
                  value={state?.address1}
                  onChange={(e) =>
                    dispatch({
                      value: e.target.value,
                      field: "address1",
                    })
                  }
                  error={state.address1Status === "error"}
                  success={state.address1Status === "success"}
                  multiline
                  rows={5}
                  disabled={pagestatus.view === true ? true : false}
                />
              </Grid>

              <Grid size={{ xs: 5, sm: 4, lg: 6 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Address2 <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>

                <MaterialInput
                  name="address"
                  value={state?.address2}
                  onChange={(e) =>
                    dispatch({
                      value: e.target.value,
                      field: "address2",
                    })
                  }
                  error={state.address2Status === "error"}
                  success={state.address2Status === "success"}
                  multiline
                  rows={5}
                  disabled={pagestatus.view === true ? true : false}
                />
              </Grid>
              <Grid container size={{ xs: 12, sm: 12, lg: 12 }}>
                <Grid size={{ xs: 5, sm: 4, lg: 3 }}>
                  <MaterialBox lineHeight={0} display="inline-block">
                    <MaterialTypography
                      component="label"
                      variant="caption"
                      fontWeight="bold"
                    >
                      Country <span style={{ color: "red" }}>*</span>
                    </MaterialTypography>
                  </MaterialBox>

                  <MaterialSelect
                    name="country"
                    value={state?.country}
                    onChange={(e) =>
                      dispatch({
                        value: e,
                        field: "country",
                      })
                    }
                    options={Country.getAllCountries().map((value) => {
                      return {
                        value: value.name,
                        label: value.name,
                        isoCode: value.isoCode,
                        phonecode: value.phonecode,
                      };
                    })}
                    error={state.countryStatus === "error"}
                    success={state.countryStatus === "success"}
                    isDisabled={pagestatus.view === true ? true : false}
                  />
                </Grid>
                <Grid size={{ xs: 5, sm: 4, lg: 3 }}>
                  <MaterialBox lineHeight={0} display="inline-block">
                    <MaterialTypography
                      component="label"
                      variant="caption"
                      fontWeight="bold"
                    >
                      State <span style={{ color: "red" }}>*</span>
                    </MaterialTypography>
                  </MaterialBox>

                  <MaterialSelect
                    name="state"
                    value={state?.state}
                    onChange={(e) =>
                      dispatch({
                        value: e,
                        field: "state",
                      })
                    }
                    options={State.getStatesOfCountry(
                      state?.country?.isoCode
                    ).map((value) => {
                      return {
                        value: value.name,
                        label: value.name,
                        isoCode: value.isoCode,
                        countryCode: value.countryCode,
                      };
                    })}
                    error={state?.stateStatus === "error"}
                    success={state.stateStatus === "success"}
                    isDisabled={pagestatus.view === true ? true : false}
                  />
                </Grid>
                <Grid size={{ xs: 5, sm: 4, lg: 3 }}>
                  <MaterialBox lineHeight={0} display="inline-block">
                    <MaterialTypography
                      component="label"
                      variant="caption"
                      fontWeight="bold"
                    >
                      City <span style={{ color: "red" }}>*</span>
                    </MaterialTypography>
                  </MaterialBox>

                  <MaterialSelect
                    name="city"
                    value={state?.city}
                    onChange={(e) => {
                      dispatch({
                        value: e,
                        field: "city",
                      });
                    }}
                    options={City?.getCitiesOfState(
                      state?.state?.countryCode || "",
                      state?.state?.isoCode
                    ).map((value) => {
                      return {
                        value: value.name,
                        label: value.name,
                      };
                    })}
                    error={state?.cityStatus === "error"}
                    success={state?.cityStatus === "success"}
                    isDisabled={pagestatus.view === true ? true : false}
                  />
                </Grid>

                <Grid size={{ xs: 5, sm: 4, lg: 3 }}>
                  <MaterialBox lineHeight={0} display="inline-block">
                    <MaterialTypography
                      component="label"
                      variant="caption"
                      fontWeight="bold"
                    >
                      Pincode
                    </MaterialTypography>
                  </MaterialBox>
                  <MaterialInput
                    name="address"
                    type="number"
                    value={state?.pincode}
                    onChange={(e) =>
                      dispatch({
                        value: e.target.value,
                        field: "pincode",
                      })
                    }
                    error={state.pincodeStatus === "error"}
                    success={state.pincodeStatus === "success"}
                    disabled={pagestatus.view === true ? true : false}
                  />
                </Grid>
              </Grid>

              <Grid size={{ xs: 5, sm: 4, lg: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    GST
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  value={state?.gstNumber}
                  onChange={(e) =>
                    dispatch({
                      value: e.target.value,
                      field: "gstNumber",
                    })
                  }
                  error={state.gstNumberStatus === "error"}
                  success={state.gstNumberStatus === "success"}
                  disabled={pagestatus.view === true ? true : false}
                />
              </Grid>
              <Grid size={{ xs: 5, sm: 4, lg: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    PAN
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  value={state?.panNumber}
                  onChange={(e) =>
                    dispatch({
                      value: e.target.value,
                      field: "panNumber",
                    })
                  }
                  error={state.panNumberStatus === "error"}
                  success={state.panNumberStatus === "success"}
                  disabled={pagestatus.view === true ? true : false}
                />
              </Grid>

              {/* section 3 */}
              <Grid container spacing={1} size={{ xs: 12, md: 12, lg: 12 }}>
                <Grid container size={{ xs: 12, md: 12, lg: 12 }}>
                  <Grid size={{ xs: 5, sm: 4, lg: 5 }}>
                    <MaterialBox lineHeight={0} display="inline-block">
                      <MaterialTypography
                        component="label"
                        variant="caption"
                        fontWeight="bold"
                      >
                        IFSC
                      </MaterialTypography>
                    </MaterialBox>
                    <MaterialInput
                      value={state?.ifscCode}
                      onChange={(e) =>
                        dispatch({
                          value: e.target.value,
                          field: "ifscCode",
                        })
                      }
                      error={state.ifscCodeStatus === "error"}
                      success={state.ifscCodeStatus === "success"}
                      disabled={pagestatus.view === true ? true : false}
                    />
                    <FormControl error>
                      <FormHelperText>{IFSCmessages}</FormHelperText>
                    </FormControl>
                  </Grid>
                  <Grid size={{ xs: 5, sm: 4, lg: 6 }} sx={{ display: "flex" }}>
                    {!pagestatus.view && (
                      <IconButton
                        onClick={verifyifsccode}
                        sx={{ color: "green" }}
                      >
                        <VerifiedOutlinedIcon />
                      </IconButton>
                    )}
                  </Grid>
                </Grid>
              </Grid>

              {/* section 4 */}
              <Grid size={{ xs: 12, md: 12, lg: 12 }} container spacing={1}>
                <Grid
                  size={{ xs: 12, md: 12, lg: 12 }}
                  sx={{ display: "flex", justifyContent: "flex-end" }}
                >
                  {!pagestatus.view ? (
                    <IconButton
                      onClick={() => dispatch({ method: "add" })}
                      sx={{ color: "blueviolet" }}
                    >
                      <AddBoxIcon />
                    </IconButton>
                  ) : (
                    ""
                  )}
                </Grid>
                {state.contactInfo.map((info, index) => (
                  <Grid
                    container
                    spacing={1}
                    key={index}
                    size={{ xs: 12, md: 12, lg: 12 }}
                    sx={{
                      border: "1px solid grey",
                      borderRadius: "20px",
                      padding: "20px",
                    }}
                  >
                    {state?.contactInfo?.length > 1 && !pagestatus.view && (
                      <span
                        style={{
                          width: "100%",
                          display: "flex",
                          justifyContent: "flex-end",
                          padding: 0,
                          margin: 0,
                        }}
                      >
                        <IconButton
                          onClick={() => {
                            setConfirmationDialog({
                              open: true,
                              title: "Delete Confirmation",
                              message: "Are You Sure to Delete Contact info ?",
                              showCancel: true,
                              onConfirm: () => {
                                dispatch({
                                  method: "delete",
                                  index,
                                  edit: pagestatus?.edit,
                                });
                                setConfirmationDialog((prev) => ({
                                  ...prev,
                                  open: false,
                                }));
                              },
                              onCancel: () => {
                                setConfirmationDialog((prev) => ({
                                  ...prev,
                                  open: false,
                                }));
                              },
                            });
                          }}
                          sx={{ color: "red" }}
                        >
                          <DeleteOutlineIcon />
                        </IconButton>
                      </span>
                    )}
                    <Grid size={{ xs: 5, sm: 4, lg: 4 }}>
                      <MaterialBox lineHeight={0} display="inline-block">
                        <MaterialTypography
                          component="label"
                          variant="caption"
                          fontWeight="bold"
                        >
                          Salution <span style={{ color: "red" }}>*</span>
                        </MaterialTypography>
                      </MaterialBox>

                      <MaterialSelect
                        name="country"
                        value={info?.salutation}
                        onChange={(e) =>
                          dispatch({
                            value: e,
                            field: "contactInfo",
                            index,
                            arrayfield: "salutation",
                          })
                        }
                        options={salutions}
                        error={info.salutationStatus === "error"}
                        success={info.salutationStatus === "success"}
                        isDisabled={pagestatus.view === true ? true : false}
                      />
                    </Grid>

                    <Grid size={{ xs: 5, sm: 4, lg: 4 }}>
                      <MaterialBox lineHeight={0} display="inline-block">
                        <MaterialTypography
                          component="label"
                          variant="caption"
                          fontWeight="bold"
                        >
                          Name <span style={{ color: "red" }}>*</span>
                        </MaterialTypography>
                      </MaterialBox>

                      <MaterialInput
                        value={info.name}
                        onChange={(e) =>
                          dispatch({
                            value: e.target.value,
                            field: "contactInfo",
                            index,
                            arrayfield: "name",
                          })
                        }
                        error={info.nameStatus === "error"}
                        success={info.nameStatus === "success"}
                        disabled={pagestatus.view === true ? true : false}
                      />
                    </Grid>

                    <Grid size={{ xs: 5, sm: 4, lg: 4 }}>
                      <MaterialBox lineHeight={0} display="inline-block">
                        <MaterialTypography
                          component="label"
                          variant="caption"
                          fontWeight="bold"
                        >
                          Designation <span style={{ color: "red" }}>*</span>
                        </MaterialTypography>
                      </MaterialBox>

                      <MaterialInput
                        value={info.designation}
                        onChange={(e) =>
                          dispatch({
                            value: e.target.value,
                            field: "contactInfo",
                            index,
                            arrayfield: "designation",
                          })
                        }
                        error={info.designationStatus === "error"}
                        success={info.designationStatus === "success"}
                        disabled={pagestatus.view === true ? true : false}
                      />
                    </Grid>

                    <Grid size={{ xs: 5, sm: 4, lg: 4 }}>
                      <MaterialBox lineHeight={0} display="inline-block">
                        <MaterialTypography
                          component="label"
                          variant="caption"
                          fontWeight="bold"
                        >
                          Phone Number<span style={{ color: "red" }}>*</span>
                        </MaterialTypography>
                      </MaterialBox>

                      <MaterialInput
                        value={info.phoneNumber}
                        onChange={(e) =>
                          dispatch({
                            value: e.target.value,
                            field: "contactInfo",
                            index,
                            arrayfield: "phoneNumber",
                          })
                        }
                        error={info.phoneNumberStatus === "error"}
                        success={info.phoneNumberStatus === "success"}
                        disabled={pagestatus.view === true ? true : false}
                      />
                    </Grid>

                    <Grid size={{ xs: 5, sm: 4, lg: 4 }}>
                      <MaterialBox lineHeight={0} display="inline-block">
                        <MaterialTypography
                          component="label"
                          variant="caption"
                          fontWeight="bold"
                        >
                          Email <span style={{ color: "red" }}>*</span>
                        </MaterialTypography>
                      </MaterialBox>

                      <MaterialInput
                        value={info.email}
                        onChange={(e) =>
                          dispatch({
                            value: e.target.value,
                            field: "contactInfo",
                            index,
                            arrayfield: "email",
                          })
                        }
                        error={info.emailStatus === "error"}
                        success={info.emailStatus === "success"}
                        disabled={pagestatus.view === true ? true : false}
                      />
                    </Grid>
                  </Grid>
                ))}
              </Grid>
            </Grid>
          </MaterialBox>
        </CardContent>
        {AccessData &&
          Array.isArray(AccessData) &&
          AccessData.some(
            (item) =>
              (item.component === "EditBranch" ||
                item.component === "AddBranch") &&
              item.can_access
          ) && (
            <MaterialBox
              display="flex"
              justifyContent="flex-end"
              alignItems="center"
            >
              {!pagestatus.view && (
                <MaterialButton
                  sx={{ m: 2 }}
                  variant="gradient"
                  color="dark"
                  onClick={create_or_edit_company}
                >
                  {pagestatus.add ? "Submit" : "Update"}
                </MaterialButton>
              )}
            </MaterialBox>
          )}

        <MaterialSnackbar
          color="success"
          icon={<NotificationsIcon />}
          title="Message"
          content="You have been submitted successfully"
          // open={snackBar.Success}
          // close={() =>
          //   setSnackBar({
          //     success: false,
          //   })
          // }
        />
      </Card>
    </DashboardLayout>
  );
};

export default AddBranch;
